
export default
function CodeExample({ children }) {
	return (
		<code>
			<pre>{children}</pre>
		</code>
	)
}
